import React, {useEffect} from 'react';
import {Modal, Form, Input, } from 'antd';

export default function StudentCoursesModal ({ visible, record, onUpdate, onCancel }) {
    const [form] = Form.useForm();
    
    useEffect(() => {
        form.setFieldsValue({
            courseGrade: (record) ? record.courseGrade : '',
            courseSemester: (record) ? record.courseSemester : '',
            course: (record) ? record.course : '',
            score: (record)? record.score : '',
        })
    }, [form, record])
   
    return (
        <Modal
            visible={visible}
            title='Update the score'
            okText='Update'
            cancelText="Cancel"
            onCancel={onCancel}
            onOk={() => {
                form
                    .validateFields()                    
                    .then((values) => {form.resetFields(); onUpdate(values)})
                    .catch((info) => {console.log('Validate Failed:', info);});
            }}
            destroyOnClose={true}
            forceRender={true} //important
        >
            <Form
                form={form}
                layout="horizontal"
                preserve={false}
            >
                <Form.Item
                    label="Grade"
                    name="courseGrade" 
                >
                    <Input disabled={true}></Input>
                </Form.Item>

                <Form.Item
                    label="Semester"
                    name="courseSemester" 
                >
                    <Input disabled={true}></Input>
                </Form.Item>

                <Form.Item
                    label="Course"
                    name="course"
                >
                    <Input disabled={true}></Input>
                </Form.Item>

                <Form.Item
                    label="Score"
                    name="score"
                    rules={[
                        {
                            required: true,                                
                        },
                    ]} 
                >
                    <Input></Input>
                </Form.Item>
            </Form>
        </Modal>
    );
};